import { combineSlices } from "@reduxjs/toolkit";

import appSlice from "./app.slices";
import bankTransferRequestsSlice from "./bankTransferRequests.slices";
import jewelleryBuyerSlice from "./jewelleryBuyer.slices";
import jewelleryInspectorSlice from "./jewelleryInspector.slices";
import loaderSlice from "./loader.slices";
import manufacturerSlice from "./manufacturer.slices";
import metalsStonesPoolsSlice from "./metalsStonesPools.slices";
import musharkaContractSlice from "./musharkaContracts.slice";
import ownedAssetsSlice from "./ownedAssets.slices";
import purchaseRequestSlice from "./purchaseRequests.slice";
import registrationStepSlice from "./registrationStep.slices.js";
import settingsSlice from "./settings.slices";
import tableSlice from "./table.slices";
import taqabethEnforcerSlice from "./taqabethEnforcer.slices";
import transactionsSlice from "./transactions.slice";
import userProfileSlice from "./userProfile.slices";
import usersSlice from "./users.slices";

const rootReducer = combineSlices(
  appSlice,
  registrationStepSlice,
  userProfileSlice,
  loaderSlice,
  usersSlice,
  settingsSlice,
  transactionsSlice,
  purchaseRequestSlice,
  bankTransferRequestsSlice,
  metalsStonesPoolsSlice,
  musharkaContractSlice,
  manufacturerSlice,
  jewelleryInspectorSlice,
  jewelleryBuyerSlice,
  taqabethEnforcerSlice,
  tableSlice,
  ownedAssetsSlice,
);

export default rootReducer;
